// tailwindcss
import './src/styles/tailwind.css';

// code highlight
import 'prismjs/themes/prism-solarizedlight.css';
